import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileSettings from '../components/ProfileSettings';
import { User, UserPreferences } from '../types';

type ProfileSettingsProps = {
  user: User;
  onEdit?: (preferences: UserPreferences) => void;
  onInterestsEdit?: () => void;
  onPreferencesEdit?: () => void;
};

const ProfileSettingPage: React.FC<ProfileSettingsProps> = ({ user,onEdit, onInterestsEdit, onPreferencesEdit }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    navigate('/');
  };

  // if (loading) {
  //   return (
  //     <div className="min-h-screen bg-gray-50 flex items-center justify-center">
  //       <div className="text-center">
  //         <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
  //           <svg className="w-8 h-8 text-primary-600 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  //           </svg>
  //         </div>
  //         <h3 className="text-lg font-semibold text-gray-900 mb-2">Loading Dashboard...</h3>
  //         <p className="text-gray-600 text-sm">Please wait while we load your business dashboard.</p>
  //       </div>
  //     </div>
  //   );
  // }

  if (!user) {
    return (
      <div className="bg-gray-50 flex items-center justify-center w-full">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No User Account Found</h3>
          <p className="text-gray-600 text-sm mb-6">
            You don't have a user account set up yet.
          </p>
          <div className="space-y-3">
            <button
              onClick={handleClose}
              className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors duration-200"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    // <div className="min-h-screen bg-gray-50">
    <ProfileSettings
      // businessMember={businessMember}
      user={user}
      onEdit={onEdit}
      onInterestsEdit={onInterestsEdit}
      onPreferencesEdit={onPreferencesEdit}
    // onClose={handleClose}
    // onUpdateProfile={handleUpdateProfile}
    />
    // </div>
  );
};

export default ProfileSettingPage;

